
const initialState = {
    matterport: [],
    matterportTitle: '',
    matterportType: ''
};

const matterport = (state = initialState, action) => {
    switch (action.type) {
        default:
            return state
    }
}

export default matterport;
